"use strict";

class Dan_QuantityInput {
	/** @var {HTMLElement} */
	#$group;

	/** @var {HTMLInputElement} */
	#$input;

	/** @var {HTMLButtonElement} */
	#$increaseButton;

	/** @var {HTMLButtonElement} */
	#$decreaseButton;


	/**
	 * @param {HTMLElement} $group
	 */
	constructor($group) {
		this.#$group = $group;
	}

	initialize() {
		this.#$input          = this.#$group.querySelector(".dan-quantity-input");
		this.#$increaseButton = this.#$group.querySelector(".dan-quantity-control[data-action='increase']");
		this.#$decreaseButton = this.#$group.querySelector(".dan-quantity-control[data-action='decrease']");

		this.#$increaseButton.addEventListener(
			"click",
			(this.onQuantityControlClick).bind(this, "increase")
		);

		this.#$decreaseButton.addEventListener(
			"click",
			(this.onQuantityControlClick).bind(this, "decrease")
		);
	}

	onQuantityControlClick(action) {
		// Get input data.
		const value = parseFloat(this.#$input.value) || 0;
		const step  = parseFloat(this.#$input.step) || 1;
		const min   = parseFloat(this.#$input.min);
		const max   = parseFloat(this.#$input.max);

		// Process value.
		let newValue = value;

		if (action === "increase") {
			newValue += step;
		} else {
			newValue -= step;
		}

		// Validate value.
		if (!isNaN(min) && newValue < min) {
			newValue = min;
		}

		if (!isNaN(max) && newValue > max) {
			newValue = max;
		}

		// Set new value.
		this.#$input.value = newValue.toString();
	}
}
